package com.rainbowclubs.rainbow

import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

@Composable
actual fun Modifier.appContentPadding(): Modifier = padding(24.dp)
